<template>
  <div class="home-three">
    <div class="catchword">
      <ul>
        <li class="col-md-12 col-xl-3">
          <div class="left">
            <img src="../../assets/imgs/catchword-01.png" alt="">
          </div>
          <div class="right">
            <div class="title">开放源码定制开发</div>
            <div class="desc">源码交付支持机构二次开发</div>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/imgs/catchword-02.png" alt="">
          </div>
          <div class="right">
            <div class="title">设计师量身定制</div>
            <div class="desc">需求定制，产品更加人性化</div>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/imgs/catchword-03.png" alt="">
          </div>
          <div class="right">
            <div class="title">全程服务保障</div>
            <div class="desc">7+24小时全天候客服服务</div>
          </div>
        </li>
        <li>
          <div class="left">
            <img src="../../assets/imgs/catchword-04.png" alt="">
          </div>
          <div class="right">
            <div class="title">多种语言开发</div>
            <div class="desc">后续兼容多语言开发环境</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="header">
      <div class="header-title">我们能做什么</div>
      <p>权华昌网络科技是一家专门从事“软件开发”服务的企业 ,产品团队让您的产品快速启动，完美落地。</p>
    </div>
    <div class="container">
      <div class="swiper-container2">
        <div class="swiper-wrapper">
          <div v-for="(item,index) in swiperList" :key="index" class="swiper-slide">
            <img :src="item.image" alt="">
            <div class="title">{{ item.title }}</div>
            <p class="desc" :title="item.desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
      <div class="swiper-button-next2"></div>
      <div class="swiper-button-prev2"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper' // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入
export default {
  data () {
    return {
      swiperList: [
        { image: require('@/assets/imgs/swiper2-00.png'), title: '云应用产品开发与销售', desc: '该服务包括开发和销售基于云计算平台的应用程序，使用户能够通过互联网访问和使用这些应用程序，无需在本地安装和维护软件。' },
        { image: require('@/assets/imgs/swiper2-01.png'), title: '大数据基础设施服务', desc: '该服务提供大规模数据存储和处理的基础设施，通过构建和管理高可用性的服务器集群、分布式存储系统和数据处理框架，帮助企业存储、管理和处理海量数据.' },
        { image: require('@/assets/imgs/swiper2-02.png'), title: '数据处理与存储服务', desc: '该服务涉及数据的采集、清洗、转换和存储等过程。通过应用各种数据处理技术和工具，帮助企业对数据进行加工和整理，以便后续分析和应用。' },
        { image: require('@/assets/imgs/swiper2-03.png'), title: '大数据产品和服务', desc: '该服务包括开发和提供基于大数据技术的产品和解决方案，如数据分析工具、数据可视化平台等，帮助企业更好地理解和利用其所拥有的大数据资源。' },
        { image: require('@/assets/imgs/swiper2-04.png'), title: '大数据挖掘分析服务', desc: '该服务通过应用数据挖掘技术，从大数据中提取有用的信息和模式，为企业提供洞察力和决策支持。包括数据建模、算法设计、模式识别等工作。' },
        { image: require('@/assets/imgs/swiper2-05.png'), title: '在线信息和数据检索服务', desc: '该服务提供在线的信息和数据检索功能，使用户能够方便地查找和获取特定的信息资源，如文档、文章、新闻等。' },
        { image: require('@/assets/imgs/swiper2-06.png'), title: '数据交换服务', desc: '该服务提供数据在不同系统和平台之间的互相交换和集成功能，确保数据的安全、完整性和一致性。该服务提供数据在不同系统和平台之间的互相交换和集成功能，确保数据的安全、完整性和一致性。' },
        { image: require('@/assets/imgs/swiper2-07.png'), title: '软件开发及信息系统集成服务', desc: '该服务涵盖软件的开发、定制和部署，以及不同系统之间的集成和互操作性的实现帮助企业构建和管理高效、灵活的信息系统。' },
        { image: require('@/assets/imgs/swiper2-08.png'), title: '软件产品销售', desc: '该服务涉及软件产品的销售和授权，包括操作系统、应用软件、开发工具等。' },
        { image: require('@/assets/imgs/swiper2-09.png'), title: '互联网接入服务', desc: '该服务提供互联网的接入和连接功能，使用户能够使用互联网上的各种资源和服务' },
        { image: require('@/assets/imgs/swiper2-10.png'), title: '物联网系统集成与服务', desc: '该服务涉及将物理设备和传感器与互联网连接，实现设备之间的数据交换和协同工作，为企业提供物联网系统的集成和支持服务。' },
        { image: require('@/assets/imgs/swiper2-11.png'), title: '公共安全信息系统集成与服务', desc: '该服务涉及公共安全领域的信息系统集成和支持，包括监控系统、应急系统、数据共享平台等。' },
        { image: require('@/assets/imgs/swiper2-12.png'), title: '工业智能化系统集成与服务', desc: '该服务帮助企业应用智能化技术和解决方案，提升生产效率和质量，改善工业流程和管理。' },
        { image: require('@/assets/imgs/swiper2-13.png'), title: '信息与自动化工程', desc: '该服务涉及信息技术和自动化技术在工程领域的应用，包括工程设计与管理软件、自动化控制系统等方面的开发和提供支持服务。' },
        { image: require('@/assets/imgs/swiper2-14.png'), title: '信息技术咨询服务', desc: '该服务提供基于信息技术的咨询和建议，帮助企业制定和实施符合其业务需求的信息技术战略和解决方案。' }]
    }
  },
  mounted () {
    this.getSwiper()
  },
  methods: {
    getSwiper () {
      this.swiper = new Swiper('.swiper-container2', {
        loop: true, // 无缝
        autoplay: { // 自动开始
          delay: 3000, // 时间间隔
          disableOnInteraction: false //* 手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        slidesPerView: 5, // 一组三个
        spaceBetween: 10, // 间隔
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-three {
  width: 100%;
  background: #f7f9fc;
  position: relative;
  padding-bottom: 130px;
  .catchword {
    width: 83.33%;
    position: absolute;
    left: 160px;
    top: -77px;
    z-index: 999;
    ul {
      display: flex;
      justify-content: space-between;
      li {
        width: 24.5625%;
        padding: 40px 0;
        background: #ffffff;
        box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        display: flex;
        align-items: center;
        .left {
          width: 25%;
          margin-left: 24px;
          img {
            width: 100%;
          }
        }
        .right {
          width: 68.7%;
          text-align: center;
          .title {
            font-size: 20px;
            font-family: Source Han Sans SC;
            font-weight: bold;
            color: #252930;
            margin-bottom: 17px;
          }
          .desc {
            font-size: 16px;
            font-family: Source Han Sans SC;
            font-weight: 500;
            color: #9fa3ac;
          }
        }
      }
    }
  }
  .header {
    text-align: center;
    overflow: hidden;
    .header-title {
      font-size: 36px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      color: #252930;
      margin: 197px 0 24px;
    }
    p {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #9fa3ac;
    }
  }
  .container {
    height: 350px;
    margin: 100px auto 0;

    .swiper-container2 {
      width: 100%;
      height: 350px;
      overflow-x: hidden;
      .swiper-wrapper {
        width: 100% !important;
      }
    }
    .swiper-slide {
      width: 232px;
      height: 100%;
      text-align: center;
      background: #ffffff;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 105px;
        height: 105px;
        margin: 33px 0 22px;
      }
      .title {
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #252930;
        width: 89%;
      }
      .desc {
        margin-top: 20px;
        width: 80%;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #56595f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .desc:hover {
        cursor: pointer;
      }
    }
    .swiper-button-next2 {
      width: 17px;
      height: 28px;
      background: url("../../assets/imgs/next-02.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: calc(50% - 25px);
      right: -86px;
      cursor: pointer;
      z-index: 999;
    }
    .swiper-button-prev2 {
      width: 17px;
      height: 28px;
      background: url("../../assets/imgs/prev-02.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: calc(50% - 25px);
      left: -85px;
      cursor: pointer;
      z-index: 999;
    }
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
    padding: 0;
    position: relative;
  }
}
@media (max-width: 1440px) {
  // .home-three .catchword{
  //     top:-200px
  //   }
  .home-three .catchword ul li .right {
    .title {
      font-size: 18px;
    }
    .desc {
      font-size: 14px;
    }
  }
  @media (max-width: 1440px) {
  .home-swiper .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 300px;
  }
  .home-three .container{
    .swiper-button-prev2{
      left: -55px;

    }
    .swiper-button-next2{
      right: -55px;
    }
  }
}
}
</style>
